import * as React from "react";
import RetryButton from "../../Common/Buttons/RetryButton";
import NiceError from "../../Common/Errors/NiceError";

export default class RenderError extends React.Component {
    public handleReload = (): void => {
        window.location.reload();
    };

    public render(): React.ReactNode {
        return (
            <div id="shopfront-error">
                <NiceError
                    actions={[
                        <RetryButton key="retry-button" onClick={this.handleReload} />,
                    ]}
                >
                    <p>Shopfront experienced an error while rendering the page, please reload and try again.</p>
                </NiceError>
            </div>
        );
    }
}
